import { observable } from "mobx";
import { Type } from "class-transformer";
import DomesticTransferPaymentResponse from "./domesticTransferPaymentResponse";
import SepaTransferPaymentResponse from "./sepaTransferPaymentResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class TransferPaymentInstructionsResponse {
  /**
   * Variable symbol, main payment demand identification.
   */
  @observable
  variableSymbol!: number;

  @observable
  @Type(() => DomesticTransferPaymentResponse)
  domesticPayment!: DomesticTransferPaymentResponse;

  @observable
  @Type(() => SepaTransferPaymentResponse)
  sepaPayment!: SepaTransferPaymentResponse;

  /**
   * Due date for transfer payment.
   */
  @observable
  @Type(() => Date)
  dueDate!: Date;
}
